/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Actions_HomeInputs */

const nl_common_actions_home = /** @type {(inputs: Common_Actions_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naar start`)
};

/**

* @param {Common_Actions_HomeInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const common_actions_home = /** @type {((inputs?: Common_Actions_HomeInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Actions_HomeInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_common_actions_home(inputs)
});
export { common_actions_home as "common.actions.home" }